





import mixins from 'vue-typed-mixins';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { OperationsMixin } from '@/main/mixins/operations';

import { store } from '../../store/edit';
import { ZAKAZKA_DRUH } from '../../constants';

export default mixins(OperationsMixin, PageModeMixin).extend({
	name: 'ZakazkaInterniDruhDuvodInput',
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		disabled() {
			return (this.isViewMode && !this.canProcess) || (this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND && this.isZakazkaDisabled);
		},
	},
});
